import React from "react";

import { useIntl } from "react-intl";

import useDecodedParams from "Hooks/useDecodedParams";

import * as S from "../Details.styles";

const SingleEnvironment = ({
  isBlackfireProjectVariable
}: {
  isBlackfireProjectVariable: boolean;
}) => {
  const intl = useIntl();
  const {
    organizationId,
    projectId
  }: { organizationId: string; projectId: string } = useDecodedParams();

  const projectVariablesUrl = `/${organizationId}/${projectId}/-/settings/variables`;
  const environmentVariablesUrl = `/${organizationId}/${projectId}/main/settings`;

  return (
    <>
      {intl.formatMessage({
        id: "integration.blackfire.warning",
        defaultMessage:
          "Blackfire variables in an environment are overriding this integration."
      })}
      <S.Link
        href={
          isBlackfireProjectVariable
            ? projectVariablesUrl
            : environmentVariablesUrl
        }
      >
        {intl.formatMessage(
          {
            id: isBlackfireProjectVariable
              ? "integration.blackfire.project.variables.url"
              : `integration.blackfire.environment.variables.url`,
            defaultMessage: " Learn more."
          },
          {
            environment: "main"
          }
        )}
      </S.Link>
    </>
  );
};

export default SingleEnvironment;
